import { Injectable, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Action, State, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { BlockingWarningDialogComponent } from './blocking-warning-dialog/blocking-warning-dialog.component';
import * as actions from './error-mesage.actions';
import { name } from './error-message.consts';
import { ErrorMessageStateModel } from './error-message.state-model';
import { LabelPrintFailureDialogComponent } from './label-print-failure-dialog/label-print-failure-dialog.component';
import { MessengerComponent } from './messenger-component/messenger-component';

const defaults = {
  counter: 0,
  errors: [],
};

@State<ErrorMessageStateModel>({
  name,
  defaults,
})
@Injectable()
export class ErrorMessageState {
  readonly #dialog: MatDialog;
  readonly #ngZone: NgZone;

  constructor(dialog: MatDialog, ngZone: NgZone) {
    this.#dialog = dialog;
    this.#ngZone = ngZone;
  }

  @Action(actions.ShowError)
  showError(
    ctx: StateContext<ErrorMessageStateModel>,
    { payload }: actions.ShowError
  ) {
    const state = ctx.getState();
    const counter = state.counter + 1;
    ctx.setState(
      patch({
        counter,
        // errors: append([{ error: payload, id: counter }]),
      })
    );

    // TODO: Llevar a un servicio.
    this.#ngZone.run(() => {
      this.#dialog.open(MessengerComponent, {
        data: payload,
        disableClose: true,
      });
    });
  }

  @Action(actions.ShowLabelPrintFailure)
  showLabelPrintFailure(
    _ctx: StateContext<ErrorMessageStateModel>,
    { payload }: actions.ShowLabelPrintFailure
  ) {
    this.#ngZone.run(() => {
      this.#dialog.open(LabelPrintFailureDialogComponent, {
        data: payload,
        disableClose: true,
        maxWidth: '90vw',
      });
    });
  }

  @Action(actions.ShowBlockingWarning)
  showBlockingWarning(
    _ctx: StateContext<ErrorMessageStateModel>,
    { payload }: actions.ShowBlockingWarning
  ) {
    this.#ngZone.run(() => {
      this.#dialog.open(BlockingWarningDialogComponent, {
        data: payload,
        disableClose: true,
      });
    });
  }
}
